export const Header = {
	QUOTE : '“A person or\norganization’s garbage\nreflects their economic\nfootprint.”',
	AUTHOR : 'Donna Maltz'
};